import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import type {
  ReferenceRangeCriticality,
  ReferenceRanges,
} from "@/types/observations";
import type { Reference } from "@curai/js-fhir-tools";

export interface QuestionnaireHistoryItem {
  questionnaireResponseId: string;
  authored?: string;
  author?: Reference;
  responseScore?: number;
  maxScore?: number;
  criticality?: ReferenceRangeCriticality;
  referenceRanges?: ReferenceRanges;
  confirmationMetadata?: {
    actor?: Reference;
    actorRole?: number;
    occurred?: string;
  } | null;
}

export interface QuestionnaireHistoryResponse {
  questionnaireHistory: QuestionnaireHistoryItem[];
}

export const useQuestionnaireHistory = ({
  patientId,
  questionnaireType,
  enabled = true,
}: {
  patientId: string;
  questionnaireType: string;
  enabled?: boolean;
}) => {
  return useApi<QuestionnaireHistoryResponse>({
    queryOptions: {
      enabled: Boolean(patientId && questionnaireType && enabled),
      queryKey: QueryKeys.Patient.MedicalRecords.Questionnaires.HISTORY(
        patientId,
        questionnaireType,
      ),
      queryFn: async () => {
        const response = await axiosInstance.get<QuestionnaireHistoryResponse>(
          "/charting/questionnaire/history",
          {
            params: { patientId, questionnaireType },
          },
        );
        return response.data;
      },
    },
  });
};
